webpackJsonp([84193535907324],{

/***/ 1196:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.ThankYouPageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageHeader = __webpack_require__(15);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Wave = __webpack_require__(378);
	
	var _Wave2 = _interopRequireDefault(_Wave);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ExceedBanner = __webpack_require__(28);
	
	var _ExceedBanner2 = _interopRequireDefault(_ExceedBanner);
	
	var _Content = __webpack_require__(6);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	__webpack_require__(1196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var ThankYouPageTemplate = exports.ThankYouPageTemplate = function ThankYouPageTemplate(_ref) {
	  var title = _ref.title,
	      mainContent = _ref.mainContent,
	      secondaryBanner = _ref.secondaryBanner,
	      footerSettings = _ref.footerSettings,
	      meta = _ref.meta;
	
	
	  return _react2.default.createElement(
	    'main',
	    { className: 'ThankYou' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { defaultTitle: meta && meta.title || title + ' | Great Start ELC' },
	      meta && _react2.default.createElement('meta', { name: 'description', content: meta.description }),
	      meta && _react2.default.createElement('link', { rel: 'canonical', href: meta.canonical }),
	      _react2.default.createElement('meta', { name: 'robots', content: 'noindex,follow' })
	    ),
	    _react2.default.createElement(_PageHeader2.default, { title: title }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'thankyou-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(_Content2.default, { src: mainContent })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col5 JoinBanner' },
	        _react2.default.createElement(
	          'h3',
	          { className: 'JoinBanner--title' },
	          secondaryBanner.title
	        ),
	        _react2.default.createElement(_Wave2.default, null),
	        _react2.default.createElement(
	          _Button2.default,
	          { to: secondaryBanner.buttonLink },
	          secondaryBanner.buttonText
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section thin' },
	        _react2.default.createElement(_ExceedBanner2.default, { footerSettings: footerSettings })
	      )
	    )
	  );
	};
	
	// Export Default HomePage for front-end
	var ThankYouPage = function ThankYouPage(_ref2) {
	  var _ref2$data = _ref2.data,
	      markdownRemark = _ref2$data.markdownRemark,
	      footerSettings = _ref2$data.footerSettings;
	  return _react2.default.createElement(ThankYouPageTemplate, _extends({}, markdownRemark.frontmatter, { footerSettings: footerSettings }));
	};
	exports.default = ThankYouPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-thank-you-js-568137aced90ad9f71ca.js